import axios from 'axios';
import { API_LOCAL } from '../constantes/constantes';

export default async function getCategories() {
  try {
    const response = await axios.get(API_LOCAL + 'categories_cs.json');
    return response.data;
  } catch (error) {
    console.error('Error al cargar el JSON:', error);
    throw error;
  }
}